export enum HTMLToPDFTabs {
  TAB_CONVERT_WEBPAGE = "TAB_CONVERT_WEBPAGE",
  TAB_CONVERT_HTML_FILE = "TAB_CONVERT_HTML_FILE",
  TAB_CONVERT_HTML_CODE = "TAB_CONVERT_HTML_CODE",
}

export default HTMLToPDFTabs;
